// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "../styles/patientappoinment.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Corrected import
// import { faUserMd } from "@fortawesome/free-solid-svg-icons"; // Corrected import

// export default function PatientAppointment({ onClose }) {
//   const [query, setQuery] = useState("");
//   const [userid, setUserid] = useState(""); //adding state for the user id
//   const [suggestions, setSuggestions] = useState([]);
//   const [selectedDoctor, setSelectedDoctor] = useState("");
//   const [selecteduserid, setSelectedUserid] = useState("");
//   const [doctor, setDoctor] = useState("");
//   const [specialization, setSpecialization] = useState("OPD");
//   const [currentScreen, setCurrentScreen] = useState(0);
//   const [appointmentDetails, setAppointmentDetails] = useState([]);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);
//   const [MAD_FULL_NAME, setFullName] = useState("");
//   const [MAD_CONTACT, setContact] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [errormeassage, setErrormessage] = useState("");
//   const patientid = localStorage.getItem("PatientCode");

//   useEffect(() => {
//     // Check if the user is already logged in by checking localStorage
//     const isLoggedIn = localStorage.getItem("isLoggedIn");
//     if (isLoggedIn) {
//       setCurrentScreen(1); // Skip the login screen if logged in
//     }
//   }, []);

//   const name = localStorage.getItem("Name");
//   const contact = localStorage.getItem("Contact");

//   const handleLogin = async () => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/AppoinmentLogin/Login`,
//         {
//           email: email,
//           password: password,
//         }
//       );

//       console.log(response.data);
//       alert("Login successful");

//       // Store login status in localStorage
//       localStorage.setItem("isLoggedIn", true);

//       // Proceed to the next screen
//       setCurrentScreen(1);
//     } catch (error) {
//       console.error(error);
//       alert("Login failed. Please try again.");
//     }
//   };

//   // const handleSearch = async (e) => {
//   //   const searchValue = e.target.value;
//   //   setQuery(searchValue);

//   //   if (searchValue.length > 2) {
//   //     try {
//   //       const response = await axios.get(
//   //         `${process.env.REACT_APP_API_BASE_URL}/User/suggest?query=${searchValue}`
//   //       );
//   //       setSuggestions(response.data);
//   //     } catch (error) {
//   //       console.error("Error fetching suggestions:", error);
//   //       setSuggestions([]);
//   //     }
//   //   } else {
//   //     setSuggestions([]);
//   //   }
//   // };
//   const handleSearch = async (e) => {
//     const searchValue = e.target.value;
//     setQuery(searchValue);

//     if (searchValue.length > 2) {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}
//         );
//         setSuggestions(response.data); // Assuming response is an array of objects with UserName property
//       } catch (error) {
//         console.error("Error fetching suggestions:", error);
//         setSuggestions([]);
//       }
//     } else {
//       setSuggestions([]);
//     }
//   };

//   useEffect(() => {
//     //fetch appoinment based on the doctor
//     const fetchAppointments = async () => {
//       if (userid) {
//         try {
//           const response = await axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Timeslot/Doctorid/${userid}`
//           );
//           setAppointmentDetails(response.data);
//         } catch (error) {
//           console.error("Error fetching appointments:", error);
//           setAppointmentDetails([]);
//         }
//       }
//     };

//     fetchAppointments();
//   }, [userid]);

//   const handleSuggestionClick = (doctorName, userId) => {
//     setSelectedDoctor(doctorName);
//     setSelectedUserid(userId);
//     setQuery(doctorName);
//     setSuggestions([]);
//   };
//   const handleConfirm = async () => {
//     try {
//       await submitAppointment();
//       await handleUpdate();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleSearchClick = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/User/doctorid/specialization`,
//         {
//           params: {
//             userId: selecteduserid,
//             specialization: specialization,
//           },
//         }
//       );

//       if (response.data.length > 0) {
//         setDoctor(response.data); // Assuming `response.data` is an array of doctor names
//         setSelectedDoctor(response.data[0].MUD_USER_NAME); // Set the first doctor from the result as the selected doctor
//         // console.log(selectedDoctor);
//         setUserid(response.data.MUD_USER_ID);
//         console.log(userid);
//         setCurrentScreen(2); // Move to the second screen
//         setErrormessage(null);
//       } else {
//         setDoctor([]); // No doctors found
//       }
//     } catch (error) {
//       if (error.response && error.response.data) {
//         console.error("Error:", error.response.data);
//         setErrormessage(error.response.data);
//       } else {
//         console.error("Error:", error.message);
//       }
//     }
//   };

//   const handleBackClick = () => {
//     setCurrentScreen((prevScreen) => (prevScreen > 0 ? prevScreen - 1 : 0));
//   };

//   const handleChannelClick = (selectedDoc) => {
//     setSelectedDoctor(selectedDoc.MUD_USER_NAME); // Set the selected doctor's name
//     setUserid(selectedDoc.MUD_USER_ID); // Set the selected doctor's user ID
//     console.log(
//       `Selected Doctor: ${selectedDoc.MUD_USER_NAME}, ID: ${selectedDoc.MUD_USER_ID}`
//     );
//     setCurrentScreen(3); // Navigate to screen 3
//   };

//   const handleBookNowClick = (appointment) => {
//     setSelectedAppointment(appointment);
//     setCurrentScreen(4);
//   };

//   const handleUpdate = async () => {
//     try {
//       await axios.patch(
//         `${process.env.REACT_APP_API_BASE_URL}/Timeslot/${selectedAppointment.MT_SLOT_ID}/incrementSeat`
//       );
//     } catch (error) {
//       console.error(
//         "Failed to update time slot",
//         error.response?.data || error.message
//       );
//     }
//   };

//   const email1 = localStorage.getItem("Email");
//   const PatientCode = localStorage.getItem("PatientCode");
//   console.log("PatientCode from localStorage:", PatientCode);

//   const submitAppointment = async () => {
//     try {
//       // Check if email is retrieved correctly
//       if (!email1) {
//         alert("Email not found. Please log in again.");
//         return;
//       }

//       // Validate the selectedAppointment fields before proceeding
//       if (!selectedAppointment) {
//         alert("No appointment selected. Please choose a time slot.");
//         return;
//       }

//       const appointmentData = {
//         MAD_FULL_NAME: name, // Make sure MAD_FULL_NAME and MAD_CONTACT are defined in the component
//         MAD_CONTACT: contact,
//         MAD_PATIENT_NO: selectedAppointment.MT_PATIENT_NO + 1,
//         MAD_APPOINMENT_DATE: selectedAppointment.MT_SLOT_DATE,
//         MAD_START_TIME: selectedAppointment.MT_START_TIME,
//         MAD_END_TIME: selectedAppointment.MT_END_TIME,
//         MAD_DOCTOR: selectedAppointment.MT_DOCTOR,
//         MAD_ALLOCATED_TIME: selectedAppointment.MT_ALLOCATED_TIME,
//         MAD_EMAIL: "", // Use retrieved email from localStorage
//         MAD_PATIENT_CODE: PatientCode,
//         MAD_SLOT_ID: selectedAppointment.MT_SLOT_ID,
//         MAD_USER_ID: selectedAppointment.MT_USER_ID,
//       };

//       // Post the appointment data
//       await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment`,
//         appointmentData
//       );

//       // alert("Appointment submitted successfully");
//       setCurrentScreen(5); // Navigate to the desired screen after successful submission
//     } catch (error) {
//       console.error("Error booking appointment:", error);
//       alert("Failed to submit the appointment. Please try again.");
//     }
//   };

//   return (
//     <div className="appoinment-screen-container">
//       <div className="mobile-frame">
//         <div
//           className={`screen login-screen ${
//             currentScreen === 0 ? "active" : ""
//           }`}
//         >
//           <h1>Login</h1>
//           <label>Email</label>
//           <input
//             type="text"
//             placeholder="please enter your email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />
//           <label>Password</label>
//           <input
//             type="password"
//             placeholder="Enter your password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//           />
//           <button onClick={handleLogin}>Login</button>
//           <p>
//             Don't have an account? <a href="/register-user">Create One</a>
//           </p>
//         </div>
//         {/* <div className={`screen1 ${currentScreen === 1 ? 'active' : ''}`}>
//           <h1>Find a doctor and book an appointment</h1>
//           <label>Doctor name</label>
//           <input
//             type="search"
//             placeholder="Enter doctor name"
//             value={query}
//             onChange={handleSearch}
//           />
//           {suggestions.length > 0 && (
//             <ul className="doctor-suggestions">
//               {suggestions.map((doctorName, index) => (
//                 <li key={index} onClick={() => handleSuggestionClick(doctorName)}>
//                   {doctorName}
//                 </li>
//               ))}
//             </ul>
//           )}
//           <label>Specialization</label>
//           <select
//             value={specialization}
//             onChange={(e) => setSpecialization(e.target.value)}
//           >
//             <option value="no">search based on specialization</option>
//             <option value="psychiatrist">Psychiatrist</option>
//             <option value="Dentist">Dentist</option>
//             <option value="cardiologist">Cardiologist</option>
//             <option value="gynecologist">Gynecologist</option>
//             <option value="pediatrician">Pediatrician</option>
//             <option value="immunologist">Immunologist</option>
//             <option value="general_practitioner">General Practitioner</option>
//           </select>
//           <p>Search doctor using name or specialization</p>
//           <button className="btn-search-appointment" onClick={handleSearchClick}>Search</button>

//           {errormeassage && (
//             <div className="error-message">
//               {errormeassage}
//             </div>
//           )}
//         </div> */}

//         {/*modal 1 When patient clciked Book Appointment it popup this modal */}

//         <div className={`screen1 ${currentScreen === 1 ? "active" : ""}`}>
//           <h1>Find a doctor and book an appointment</h1>
//           <label>Doctor name</label>
//           <input
//             type="search"
//             placeholder="Enter doctor name"
//             value={query}
//             onChange={handleSearch}
//           />
//           {suggestions.length > 0 && (
//             <ul className="doctor-suggestions">
//               {suggestions.map((doctor, index) => (
//                 <li
//                   key={index}
//                   onClick={() =>
//                     handleSuggestionClick(doctor.UserName, doctor.UserId)
//                   }
//                 >
//                   {doctor.UserName}
//                 </li>
//               ))}
//             </ul>
//           )}
//           <label>Specialization</label>
//           <select
//             value={specialization}
//             onChange={(e) => setSpecialization(e.target.value)}
//           >
//             <option value="no">Search based on specialization</option>
//             <option value="psychiatrist">Psychiatrist</option>
//             <option value="Dentist">Dentist</option>
//             <option value="cardiologist">Cardiologist</option>
//             <option value="gynecologist">Gynecologist</option>
//             <option value="pediatrician">Pediatrician</option>
//             <option value="immunologist">Immunologist</option>
//             <option value="general_practitioner">General Practitioner</option>
//           </select>
//           <p>Search doctor using name or specialization</p>
//           <button
//             className="btn-search-appointment"
//             onClick={handleSearchClick}
//           >
//             Search
//           </button>

//           {/* Display the error message if there is one */}
//           {errormeassage && (
//             <div className="error-message">{errormeassage}</div>
//           )}
//         </div>

//         {/*modal 2 Doctor filtering section, after clicked Noo an appointment it opens this modal */}
//         <div className={`screen2 ${currentScreen === 2 ? "active" : ""}`}>
//           <button onClick={handleBackClick}>Back</button>
//           {doctor.length > 0 ? (
//             <ul className="doctor-list">
//               {doctor.map((doc, index) => (
//                 <li key={index} className="doctor-item">
//                   <div className="doctor-details">
//                     <span>{doc.MUD_USER_NAME}</span>
//                     <p>{doc.MUD_SPECIALIZATION}</p>
//                   </div>
//                   <span
//                     className="channel-icon"
//                     onClick={() => handleChannelClick(doc)}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <FontAwesomeIcon icon={faUserMd} />
//                   </span>
//                 </li>
//               ))}
//             </ul>
//           ) : (
//             <p>No doctors available.</p>
//           )}
//         </div>

//           {/*modal 3 After the selecting the doctor it opens this modal */}
//         <div className={`screen3 ${currentScreen === 3 ? "active" : ""}`}>
//           <button onClick={handleBackClick} className="back-button">
//             Back
//           </button>
//           <div>
//             {appointmentDetails.length > 0 ? (
//               <ul className="appoinments-lists">
//                 {appointmentDetails.map((appointment, index) => {
//                   const appointmentDate = new Date(appointment.MT_SLOT_DATE);
//                   const formattedDate = appointmentDate.toLocaleDateString();
//                   const startTime = new Date(
//                     `1970-01-01T${appointment.MT_START_TIME}`
//                   ).toLocaleTimeString("en-LK", {
//                     timeZone: "Asia/Colombo",
//                     hour: "numeric",
//                     minute: "numeric",
//                     hour12: true,
//                   });
//                   const endTime = new Date(
//                     `1970-01-01T${appointment.MT_END_TIME}`
//                   ).toLocaleTimeString("en-LK", {
//                     timeZone: "Asia/Colombo",
//                     hour: "numeric",
//                     minute: "numeric",
//                     hour12: true,
//                   });

//                   // Convert the end time into a Date object for comparison
//                   const endDate = new Date(`${formattedDate} ${endTime}`);
//                   const currentTime = new Date();

//                   // Check if the appointment date and time has passed
//                   const isPastDate =
//                     appointmentDate < new Date().setHours(0, 0, 0, 0);
//                   const isBookingClosed = currentTime > endDate; // Check if current time exceeds the end time

//                   return (
//                     <li key={index}>
//                       <p>
//                         Appointment Date:{" "}
//                         {appointment.MT_SLOT_DATE.split("T")[0]}
//                       </p>
//                       <p>
//                         Time Duration: {startTime} - {endTime}
//                       </p>
//                       {isPastDate ? (
//                         <p style={{ color: "red" }}>
//                           Sorry, the appointment time has passed.
//                         </p>
//                       ) : isBookingClosed ? (
//                         <p style={{ color: "red" }}>
//                           Bookings are closed for this appointment.
//                         </p>
//                       ) : appointment.MT_PATIENT_NO >=
//                         appointment.MT_MAXIMUM_PATIENTS ? (
//                         <p style={{ color: "red" }}>Bookings are filled</p>
//                       ) : (
//                         <button onClick={() => handleBookNowClick(appointment)}>
//                           Book Now
//                         </button>
//                       )}
//                     </li>
//                   );
//                 })}
//               </ul>
//             ) : (
//               <p>No appointments available.</p>
//             )}
//           </div>
//         </div>

//         {/* modal 4: Appointment Confirmation */}
//         <div className={`screen4 ${currentScreen === 4 ? "active" : ""}`}>
//           {selectedAppointment && (
//             <div className="appointment-card">
//               <h2>Appointment details</h2>

//               <div className="appointment-details">
//                 <p>
//                   <strong>Name:</strong> {name}
//                 </p>
//                 <p>
//                   <strong>Patient Number:</strong>{" "}
//                   {selectedAppointment.MT_PATIENT_NO + 1}
//                 </p>
//                 <p>
//                   <strong>Time:</strong>{" "}
//                   {new Date(
//                     `1970-01-01T${selectedAppointment.MT_ALLOCATED_TIME}`
//                   ).toLocaleTimeString("en-LK", {
//                     timeZone: "Asia/Colombo",
//                     hour: "numeric",
//                     minute: "numeric",
//                     hour12: true,
//                   })}
//                 </p>
//                 <p>
//                   <strong>Appointment Date:</strong>{" "}
//                   {selectedAppointment.MT_SLOT_DATE.split("T")[0]}
//                 </p>
//                 <p>
//                   <strong>Doctor Available Time:</strong>{" "}
//                   {new Date(
//                     `1970-01-01T${selectedAppointment.MT_START_TIME}`
//                   ).toLocaleTimeString("en-LK", {
//                     timeZone: "Asia/Colombo",
//                     hour: "numeric",
//                     minute: "numeric",
//                     hour12: true,
//                   })}{" "}
//                   -{" "}
//                   {new Date(
//                     `1970-01-01T${selectedAppointment.MT_END_TIME}`
//                   ).toLocaleTimeString("en-LK", {
//                     timeZone: "Asia/Colombo",
//                     hour: "numeric",
//                     minute: "numeric",
//                     hour12: true,
//                   })}
//                 </p>
//               </div>

//               <div className="button-group">
//                 <button className="btn-confirm" onClick={handleConfirm}>
//                   confirm
//                 </button>
//                 <button className="btn-back" onClick={handleBackClick}>
//                   Back
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Screen 5: Confirmation Message */}
//         <div className={`screen5 ${currentScreen === 5 ? "active" : ""}`}>
//           <h1>Thank you for your booking!</h1>
//           <p>Your appointment has been successfully booked.</p>

//           {/* <button onClick={handleBackClick} >Back</button> */}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserMd,
  faArrowLeft,
  faSearch,
  faCalendarAlt,
  faClock,
  faUser,
  faIdBadge,
  faCheckCircle,
  faPhone,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Avatar,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Snackbar,
  Alert,
  useTheme,
  useMediaQuery,
  Stepper,
  Step,
  StepLabel,
  Badge,
  Container,
  CardHeader,
  CardActionArea,
  CardMedia,
  CardActions,
  Fade,
  Grow,
  Zoom,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { green, blue, red, orange, purple } from "@mui/material/colors";
import { motion } from "framer-motion";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledCard = styled(Card)(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  borderRadius: 16,
  boxShadow: theme.shadows[4],
  overflow: "hidden",
  backgroundColor: theme.palette.background.paper,
}));

const DoctorCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderRadius: 12,
  transition: "transform 0.3s, box-shadow 0.3s",
  "&:hover": {
    transform: "translateY(-8px)",
    boxShadow: theme.shadows[8],
  },
}));

const BookButton = styled(Button)(({ theme }) => ({
  backgroundColor: green[600],
  color: "white",
  fontWeight: 600,
  padding: theme.spacing(1, 3),
  borderRadius: 8,
  "&:hover": {
    backgroundColor: green[800],
    boxShadow: theme.shadows[4],
  },
}));

const BackButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderRadius: 8,
  padding: theme.spacing(1, 2),
}));

const SpecializationChip = styled(Chip)(({ theme }) => ({
  marginRight: theme.spacing(1),
  marginBottom: theme.spacing(1),
  backgroundColor: purple[100],
  color: purple[800],
  fontWeight: 500,
}));

const steps = ["Login", "Find Doctor", "Select Time", "Confirm"];

export default function PatientAppointment({ onClose }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [query, setQuery] = useState("");
  const [userid, setUserid] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [selecteduserid, setSelectedUserid] = useState("");
  const [doctor, setDoctor] = useState("");
  const [specialization, setSpecialization] = useState("OPD");
  const [currentScreen, setCurrentScreen] = useState(3); // Skip to Available Time Slots
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [MAD_FULL_NAME, setFullName] = useState("");
  const [MAD_CONTACT, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errormeassage, setErrormessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const patientid = localStorage.getItem("PatientCode");
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn) {
      setCurrentScreen(3); // Skip to Available Time Slots
      setActiveStep(2);
    }
  }, []);

  // Load all timeslots when component mounts
  useEffect(() => {
    const fetchAllTimeslots = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/Timeslot`
        );
        setAppointmentDetails(response.data);
      } catch (error) {
        console.error("Error fetching all timeslots:", error);
        setAppointmentDetails([]);
      }
    };

    fetchAllTimeslots();
  }, []);

  const name = localStorage.getItem("Name");
  const contact = localStorage.getItem("Contact");

  const handleLogin = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/AppoinmentLogin/Login`,
        {
          email: email,
          password: password,
        }
      );

      localStorage.setItem("isLoggedIn", true);
      setCurrentScreen(3); // Skip to Available Time Slots
      setActiveStep(2);
      setOpenSuccess(true);
    } catch (error) {
      console.error(error);
      setErrormessage(
        "Login failed. Please check your credentials and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setQuery(searchValue);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/User/doctors`
      );
      
      // Filter doctors: only show users with type "Doc"
      let doctorUsers = response.data.filter(user => user.MUD_USER_TYPE === "Doc");
      
      // Further filter based on search value
      if (searchValue && searchValue.length > 0) {
        doctorUsers = doctorUsers.filter(doctor => 
          doctor.MUD_USER_NAME && doctor.MUD_USER_NAME.toLowerCase().includes(searchValue.toLowerCase())
        );
      }
      setSuggestions(doctorUsers);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setSuggestions([]);
    }
  };

  // Function to load all doctors when input is focused
  const handleInputFocus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/User/doctors`
      );
      // Filter to show only users with type "Doc"
      const doctorUsers = response.data.filter(user => user.MUD_USER_TYPE === "Doc");
      setSuggestions(doctorUsers);
    } catch (error) {
      console.error("Error fetching doctors:", error);
      setSuggestions([]);
    }
  };

  useEffect(() => {
    const fetchAppointments = async () => {
      if (userid) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Timeslot/Doctorid/${userid}`
          );
          setAppointmentDetails(response.data);
        } catch (error) {
          console.error("Error fetching appointments:", error);
          setAppointmentDetails([]);
        }
      }
    };

    fetchAppointments();
  }, [userid]);

  // const handleSuggestionClick = (doctorName, userId) => {
  //   setSelectedDoctor(doctorName);
  //   setSelectedUserid(userId);
  //   setQuery(doctorName);
  //   setSuggestions([]);
  // };
  const handleSuggestionClick = (doctorName, userId) => {
    setSelectedDoctor(doctorName);
    setSelectedUserid(userId);
    setQuery(doctorName);
    setSuggestions([]);
  };
  // const handleConfirm = async () => {
  //   try {
  //     await submitAppointment();
  //     await handleUpdate();
  //     setActiveStep(3);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const handleSearchClick = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/User/doctorid/specialization`,
  //       {
  //         params: {
  //           userId: selecteduserid,
  //           specialization: specialization,
  //         },
  //       }
  //     );

  //     if (response.data.length > 0) {
  //       setDoctor(response.data);
  //       setSelectedDoctor(response.data[0].MUD_USER_NAME);
  //       setUserid(response.data.MUD_USER_ID);
  //       setCurrentScreen(2);
  //       setActiveStep(2);
  //       setErrormessage(null);
  //     } else {
  //       setDoctor([]);
  //       setErrormessage("No doctors found with the selected criteria.");
  //     }
  //   } catch (error) {
  //     if (error.response && error.response.data) {
  //       console.error("Error:", error.response.data);
  //       setErrormessage(error.response.data.message || "An error occurred");
  //     } else {
  //       console.error("Error:", error.message);
  //       setErrormessage("Failed to search. Please try again.");
  //     }
  //   }
  // };


  //MOdify this function, patient search the docotrs by using name it directly navigate to avaiable timeslots screen and filter by specialization then it goes avaible docotos avaible time slots
 const handleSearchClick = async () => {
  try {
    if (query && selecteduserid) {
      // Directly go to available timeslots if searched by name
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/Timeslot/Doctorid/${selecteduserid}`
      );
      setAppointmentDetails(response.data);
      setCurrentScreen(3); // Skip doctors list
      setActiveStep(2);
    } else if (specialization && specialization !== "OPD") {
      // First load doctors by specialization
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/User/doctorid/specialization`,
        { params: { specialization } }
      );

      if (response.data.length > 0) {
        setDoctor(response.data);
        setCurrentScreen(2); // Go to doctors list
        setActiveStep(2);
      } else {
        setDoctor([]);
        setErrormessage("No doctors found with the selected criteria.");
      }
    } else {
      setErrormessage("Please select a doctor or specialization");
    }
  } catch (error) {
    console.error("Search error:", error);
    setErrormessage("Failed to search. Please try again.");
  }
};


  // const handleBackClick = () => {
  //   if (currentScreen > 0) {
  //     setCurrentScreen(currentScreen - 1);
  //     setActiveStep(activeStep - 1);
  //   }
  // };

  //MOdify this back function, patient search the docotrs by using name it directly navigate to avaiable timeslots screen and filter by specialization then it goes avaible docotos avaible time slots
  const handleBackClick = () => {
    if (currentScreen === 3) {
      if (query && selecteduserid) {
        setCurrentScreen(1);
        setActiveStep(1);
      } else {
        setCurrentScreen(2);
        setActiveStep(2);
      }
    } else if (currentScreen === 2) {
      setCurrentScreen(1);
      setActiveStep(1);
    } else if (currentScreen > 0) {
      setCurrentScreen(currentScreen - 1);
      setActiveStep(activeStep - 1);
    }
  };

  const handleChannelClick = (selectedDoc) => {
    setSelectedDoctor(selectedDoc.MUD_USER_NAME);
    setUserid(selectedDoc.MUD_USER_ID);
    setCurrentScreen(3);
    setActiveStep(2);
  };

  const handleBookNowClick = (appointment) => {
    setSelectedAppointment(appointment);
    setCurrentScreen(4);
  };

  // const handleUpdate = async () => {
  //   try {
  //     await axios.patch(
  //       `${process.env.REACT_APP_API_BASE_URL}/Timeslot/${selectedAppointment.MT_SLOT_ID}/incrementSeat`
  //     );
  //   } catch (error) {
  //     console.error(
  //       "Failed to update time slot",
  //       error.response?.data || error.message
  //     );
  //   }
  // };

  const handleUpdate = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/Timeslot/incrementSeat`, // endpoint without ID in URL
        {}, // empty body
        {
          headers: {
            "Content-Type": "application/json"
          },
          params: { id: selectedAppointment.MT_SLOT_ID } // sending as query param
        }
      );
  
      console.log("Seat incremented successfully:", response.data);
      // Optionally update UI here
    } catch (error) {
      console.error(
        "Failed to update time slot:",
        error.response?.data || error.message
      );
    }
  };
  

  const email1 = localStorage.getItem("Email");
  const PatientCode = localStorage.getItem("PatientCode");

  // const submitAppointment = async () => {
  //   try {
  //     if (!email1) {
  //       setErrormessage("Session expired. Please log in again.");
  //       return;
  //     }

  //     if (!selectedAppointment) {
  //       setErrormessage("No appointment selected. Please choose a time slot.");
  //       return;
  //     }

  //     const appointmentData = {
  //       MAD_FULL_NAME: name,
  //       MAD_CONTACT: contact,
  //       MAD_PATIENT_NO: selectedAppointment.MT_PATIENT_NO + 1,
  //       MAD_APPOINMENT_DATE: selectedAppointment.MT_SLOT_DATE,
  //       MAD_START_TIME: selectedAppointment.MT_START_TIME,
  //       MAD_END_TIME: selectedAppointment.MT_END_TIME,
  //       MAD_DOCTOR: selectedAppointment.MT_DOCTOR,
  //       MAD_ALLOCATED_TIME: selectedAppointment.MT_ALLOCATED_TIME,
  //       MAD_EMAIL: "",
  //       MAD_PATIENT_CODE: PatientCode,
  //       MAD_SLOT_ID: selectedAppointment.MT_SLOT_ID,
  //       MAD_USER_ID: selectedAppointment.MT_USER_ID,
  //       MAD_CONFIRMATION_SENT: true,
  //       MAD_CONFIRMATION_SENT_DATE: null
  //     };

  //     await axios.post(
  //       `${process.env.REACT_APP_API_BASE_URL}/Appointment`,
  //       appointmentData
  //     );

  //     setCurrentScreen(5);
  //   } catch (error) {
  //     console.error("Error booking appointment:", error);
  //     setErrormessage("Failed to submit the appointment. Please try again.");
  //   }
  // };

  const submitAppointment = async () => {
  try {
    if (!selectedAppointment) {
      setErrormessage("No appointment selected. Please choose a time slot.");
      return;
    }
    const appointmentData = {
      MAD_FULL_NAME: name,
      MAD_CONTACT: contact,
      MAD_PATIENT_NO: selectedAppointment.MT_PATIENT_NO + 1,
      MAD_APPOINMENT_DATE: selectedAppointment.MT_SLOT_DATE,
      MAD_START_TIME: selectedAppointment.MT_START_TIME,
      MAD_END_TIME: selectedAppointment.MT_END_TIME,
      MAD_DOCTOR: selectedAppointment.MT_DOCTOR,
      MAD_ALLOCATED_TIME: selectedAppointment.MT_ALLOCATED_TIME,
      MAD_EMAIL: "",
      MAD_PATIENT_CODE: PatientCode,
      MAD_SLOT_ID: selectedAppointment.MT_SLOT_ID,
      MAD_USER_ID: selectedAppointment.MT_USER_ID,
      MAD_CONFIRMATION_SENT: true,
      MAD_CONFIRMATION_SENT_DATE: null
    };
    return await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/Appointment`,
      appointmentData
    );
  } catch (error) {
    console.error("Error booking appointment:", error);
    setErrormessage("Failed to submit the appointment. Please try again.");
    throw error;
  }
};
const sendAppointmentConfirmation = async (appointmentId) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/Appointment/send-appointment-confirmation/${appointmentId}`
    );
    console.log("Confirmation email sent successfully");
  } catch (error) {
    console.error("Error sending confirmation email:", error);
    // You might want to handle this differently - maybe just log it but not show to user
    // since the appointment was already created successfully
  }
};

const handleConfirm = async () => {
  try {
    const appointmentResponse = await submitAppointment();
    const appointmentId = appointmentResponse.data.MAD_APPOINMENT_ID;
    await sendAppointmentConfirmation(appointmentId);
    await handleUpdate();
    setActiveStep(3);
  } catch (error) {
      console.error(error);}
};
  

  const handleCloseSnackbar = () => {
    setOpenSuccess(false);
    setErrormessage("");
  };

  // const renderScreen0 = () => (
  //   <Fade in={true} timeout={500}>
  //     <Container maxWidth="sm" sx={{ py: 4 }}>
  //       <StyledCard>
  //         <CardContent sx={{ p: 4 }}>
  //           <Box textAlign="center" mb={4}>
  //             <Typography
  //               variant="h4"
  //               component="h1"
  //               gutterBottom
  //               color="primary"
  //               fontWeight="bold"
  //             >
  //               Welcome Back
  //             </Typography>
  //             <Typography variant="body1" color="text.secondary">
  //               Sign in to book your next appointment
  //             </Typography>
  //           </Box>
  //           <Box component="form" sx={{ mt: 3 }}>
  //             <TextField
  //               fullWidth
  //               label="Email Address"
  //               variant="outlined"
  //               margin="normal"
  //               placeholder="your.email@example.com"
  //               value={email}
  //               onChange={(e) => setEmail(e.target.value)}
  //               InputProps={{
  //                 startAdornment: (
  //                   <InputAdornment position="start">
  //                     <FontAwesomeIcon icon={faUser} />
  //                   </InputAdornment>
  //                 ),
  //               }}
  //               sx={{ mb: 2 }}
  //             />
  //             <TextField
  //               fullWidth
  //               label="Password"
  //               variant="outlined"
  //               margin="normal"
  //               type="password"
  //               placeholder="Enter your password"
  //               value={password}
  //               onChange={(e) => setPassword(e.target.value)}
  //               InputProps={{
  //                 startAdornment: (
  //                   <InputAdornment position="start">
  //                     <FontAwesomeIcon icon={faIdBadge} />
  //                   </InputAdornment>
  //                 ),
  //               }}
  //               sx={{ mb: 2 }}
  //             />
  //             <Button
  //               fullWidth
  //               variant="contained"
  //               color="primary"
  //               size="large"
  //               sx={{ mt: 2, py: 1.5, borderRadius: 2 }}
  //               onClick={handleLogin}
  //               disabled={loading}
  //             >
  //               {loading ? (
  //                 <CircularProgress size={24} color="inherit" />
  //               ) : (
  //                 "Sign In"
  //               )}
  //             </Button>
  //             <Typography
  //               variant="body2"
  //               align="center"
  //               sx={{ mt: 3, color: "text.secondary" }}
  //             >
  //               Don't have an account?{" "}
  //               <Button
  //                 color="primary"
  //                 href="/register-user"
  //                 sx={{ textTransform: "none" }}
  //               >
  //                 Create One
  //               </Button>
  //             </Typography>
  //           </Box>
  //         </CardContent>
  //       </StyledCard>
  //     </Container>
  //   </Fade>
  // );

  // const renderScreen1 = () => (
    <Grow in={true} timeout={500}>
      <Container maxWidth="lg">
        <Box sx={{ 
          minHeight: '80vh',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          borderRadius: 3,
          p: { xs: 2, md: 4 },
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
        }}>
          <Card sx={{ 
            background: 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(10px)',
            borderRadius: 3,
            border: '1px solid rgba(255,255,255,0.2)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
          }}>
            <CardContent sx={{ p: { xs: 2, md: 4 } }}>
              <Box textAlign="center" mb={4}>
                <Box sx={{ 
                  background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  mb: 2
                }}>
                  <Typography
                    variant={isMobile ? "h5" : "h4"}
                    component="h1"
                    gutterBottom
                    fontWeight="bold"
                  >
                    🏥 Find Your Doctor
                  </Typography>
                </Box>
                <Typography 
                  variant="body1" 
                  color="text.secondary"
                  sx={{ maxWidth: 600, mx: 'auto', lineHeight: 1.6 }}
                >
                  Search by name or specialization to book an appointment with our qualified medical professionals
                </Typography>
              </Box>

              <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} md={6}>
                  <Box sx={{ position: 'relative' }}>
                    <TextField
                      fullWidth
                      label="Search Doctor by Name"
                      variant="outlined"
                      margin="normal"
                      placeholder="E.g. Dr. John Smith"
                      value={query}
                      onChange={handleSearch}
                      onFocus={handleInputFocus}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 3,
                          backgroundColor: 'rgba(255,255,255,0.9)',
                          backdropFilter: 'blur(10px)',
                          boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                          '&:hover': {
                            boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                          },
                          '&.Mui-focused': {
                            boxShadow: '0 8px 25px rgba(33, 150, 243, 0.2)',
                            border: '2px solid #2196F3',
                          }
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 600,
                          color: '#1976d2'
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FontAwesomeIcon 
                              icon={faSearch} 
                              style={{ 
                                color: '#2196F3', 
                                fontSize: '1.2rem' 
                              }} 
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                {suggestions.length > 0 && (
                  <Paper
                    elevation={3}
                    sx={{ maxHeight: 200, overflow: "auto", mt: 1 }}
                  >
                    <List>
                      {suggestions.map((doctor, index) => (
                        <ListItem
                          key={index}
                          button
                          onClick={() =>
                            handleSuggestionClick(
                              doctor.MUD_USER_NAME,
                              doctor.MUD_USER_ID
                            )
                          }
                          sx={{
                            "&:hover": {
                              backgroundColor: "action.hover",
                            },
                          }}
                        >
                          <ListItemAvatar>
                            <Avatar
                              sx={{ bgcolor: blue[100], color: blue[600] }}
                            >
                              {doctor.MUD_USER_NAME && doctor.MUD_USER_NAME.charAt ? doctor.MUD_USER_NAME.charAt(0) : '?'}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={doctor.MUD_USER_NAME || 'Unknown Doctor'}
                            secondary={
                              doctor.MUD_SPECIALIZATION || "General Practitioner"
                            }
                          />
                        </ListItem>
                      ))}
                        </List>
                      </Paper>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    select
                    label="Search by Specialization"
                    variant="outlined"
                    margin="normal"
                    value={specialization}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 3,
                        backgroundColor: 'rgba(255,255,255,0.9)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                        '&:hover': {
                          boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                        },
                        '&.Mui-focused': {
                          boxShadow: '0 8px 25px rgba(33, 150, 243, 0.2)',
                          border: '2px solid #2196F3',
                        }
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 600,
                        color: '#1976d2'
                      }
                    }}
                    onChange={(e) => setSpecialization(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FontAwesomeIcon 
                            icon={faUserMd} 
                            style={{ 
                              color: '#2196F3', 
                              fontSize: '1.2rem' 
                            }} 
                          />
                        </InputAdornment>
                      ),
                    }}
                >
                  <MenuItem value="OPD">Search by Specialization</MenuItem>
                  <MenuItem value="psychiatrist">Psychiatrist</MenuItem>
                  <MenuItem value="Dentist">Dentist</MenuItem>
                  <MenuItem value="cardiologist">Cardiologist</MenuItem>
                  <MenuItem value="gynecologist">Gynecologist</MenuItem>
                  <MenuItem value="pediatrician">Pediatrician</MenuItem>
                  <MenuItem value="immunologist">Immunologist</MenuItem>
                </TextField>
              </Grid>
            </Grid>

              <Box textAlign="center" mt={4}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<FontAwesomeIcon icon={faSearch} />}
                  sx={{
                    px: { xs: 4, md: 6 },
                    py: 1.5,
                    borderRadius: 25,
                    fontSize: "1rem",
                    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                    boxShadow: '0 4px 20px rgba(33, 150, 243, 0.3)',
                    '&:hover': {
                      boxShadow: '0 6px 25px rgba(33, 150, 243, 0.4)',
                      transform: 'translateY(-2px)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                  onClick={handleSearchClick}
                  disabled={!query && specialization === "OPD"}
                >
                  Search Doctors
                </Button>
              </Box>

              {errormeassage && (
                <Alert 
                  severity="error" 
                  sx={{ 
                    mt: 3,
                    borderRadius: 2,
                    '& .MuiAlert-icon': {
                      fontSize: '1.5rem'
                    }
                  }}
                >
                  {errormeassage}
                </Alert>
              )}
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Grow>
  // );

  const renderScreen2 = () => (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        py: 4,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 50%)',
          pointerEvents: 'none',
        },
      }}
    >
      <Zoom in={true} timeout={500}>
        <Container maxWidth="xl">
          <Card
            sx={{
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(20px)',
              borderRadius: '24px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
              overflow: 'visible',
              mt: 2,
            }}
          >
            <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
              <Box 
                display="flex" 
                alignItems="center" 
                mb={3}
                sx={{
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: { xs: 2, sm: 0 },
                }}
              >
                <Button
                  startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                  onClick={handleBackClick}
                  variant="outlined"
                  sx={{
                    mr: { sm: 2 },
                    color: 'white',
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: '12px',
                    px: 3,
                    py: 1,
                    '&:hover': {
                      borderColor: 'rgba(255, 255, 255, 0.5)',
                      backgroundColor: 'rgba(255, 255, 255, 0.2)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.2)',
                    },
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  }}
                >
                  Back
                </Button>
                <Typography
                  variant="h4"
                  component="h1"
                  gutterBottom
                  sx={{
                    textAlign: { xs: 'center', sm: 'center' },
                    width: '100%',
                    mb: 0,
                    fontWeight: 700,
                    background: 'linear-gradient(135deg, #ffffff 0%, #f0f8ff 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    color: 'transparent',
                    textShadow: '0 4px 20px rgba(255, 255, 255, 0.3)',
                    fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' },
                  }}
                >
                  Available Doctors
                </Typography>
              </Box>

              {doctor.length > 0 ? (
                <Grid container spacing={3}>
                  {doctor.map((doc, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Card
                        sx={{
                          background: 'rgba(255, 255, 255, 0.15)',
                          backdropFilter: 'blur(15px)',
                          borderRadius: '20px',
                          border: '1px solid rgba(255, 255, 255, 0.2)',
                          boxShadow: '0 12px 30px rgba(0, 0, 0, 0.1)',
                          transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                          cursor: 'pointer',
                          overflow: 'hidden',
                          position: 'relative',
                          '&:hover': {
                            transform: 'translateY(-10px) scale(1.02)',
                            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
                            background: 'rgba(255, 255, 255, 0.25)',
                          },
                          '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: 'linear-gradient(90deg, #667eea, #764ba2, #f093fb)',
                          },
                        }}
                        onClick={() => handleChannelClick(doc)}
                      >
                        <CardContent sx={{ p: 3 }}>
                          <Box display="flex" alignItems="center" mb={2}>
                            <Avatar
                              sx={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                width: 64,
                                height: 64,
                                mr: 2,
                                fontSize: '1.5rem',
                                fontWeight: 'bold',
                                boxShadow: '0 8px 20px rgba(102, 126, 234, 0.3)',
                                border: '3px solid rgba(255, 255, 255, 0.3)',
                              }}
                            >
                              {doc.MUD_USER_NAME && doc.MUD_USER_NAME.charAt ? doc.MUD_USER_NAME.charAt(0) : '?'}
                            </Avatar>
                            <Box sx={{ flex: 1 }}>
                              <Typography 
                                variant="h6" 
                                fontWeight="bold"
                                sx={{
                                  color: 'white',
                                  textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                                  fontSize: { xs: '1.1rem', sm: '1.25rem' },
                                  lineHeight: 1.2,
                                }}
                              >
                                {doc.MUD_USER_NAME}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: 'rgba(255, 255, 255, 0.8)',
                                  mt: 0.5,
                                  fontSize: '0.9rem',
                                }}
                              >
                                {doc.MUD_SPECIALIZATION}
                              </Typography>
                            </Box>
                          </Box>
                          
                          <Box mt={2}>
                            {doc.MUD_SPECIALIZATION && (
                              <Chip
                                label={doc.MUD_SPECIALIZATION}
                                size="small"
                                sx={{
                                  background: 'rgba(255, 255, 255, 0.2)',
                                  color: 'white',
                                  border: '1px solid rgba(255, 255, 255, 0.3)',
                                  fontSize: '0.75rem',
                                  '& .MuiChip-label': {
                                    px: 1.5,
                                  },
                                }}
                              />
                            )}
                          </Box>
                          
                          <Box mt={3} display="flex" justifyContent="flex-end">
                            <Button
                              endIcon={<FontAwesomeIcon icon={faUserMd} />}
                              variant="contained"
                              size="small"
                              sx={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                borderRadius: '12px',
                                px: 2,
                                py: 1,
                                fontSize: '0.8rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                boxShadow: '0 6px 15px rgba(102, 126, 234, 0.3)',
                                '&:hover': {
                                  background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                                  transform: 'translateY(-2px)',
                                  boxShadow: '0 8px 20px rgba(102, 126, 234, 0.4)',
                                },
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                              }}
                            >
                              View Availability
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  minHeight="300px"
                  sx={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '20px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(10px)',
                    p: 4,
                  }}
                >
                  <FontAwesomeIcon 
                    icon={faUserMd} 
                    style={{ 
                      fontSize: '4rem', 
                      color: 'rgba(255, 255, 255, 0.6)', 
                      marginBottom: '16px' 
                    }} 
                  />
                  <Typography 
                    variant="h6" 
                    gutterBottom
                    sx={{
                      color: 'white',
                      textAlign: 'center',
                      fontWeight: 600,
                    }}
                  >
                    No doctors available
                  </Typography>
                  <Typography 
                    variant="body2"
                    sx={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textAlign: 'center',
                    }}
                  >
                    Try adjusting your search criteria
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Container>
      </Zoom>
    </Box>
  );

  //Without date filtering process
  // const renderScreen3 = () => (
  //   <Slide direction="up" in={true} mountOnEnter unmountOnExit>
  //     <Container maxWidth="xl">
  //       <Box sx={{ mt: -2 }}>
  //         <CardContent>
  //           <Box display="flex" alignItems="center" mb={4}>
  //             <BackButton
  //               startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
  //               onClick={handleBackClick}
  //               variant="outlined"
  //               sx={{ mr: 2 }}
  //             >
  //               Back
  //             </BackButton>
  //             <Typography
  //               variant="h4"
  //               component="h1"
  //               gutterBottom
  //               color="primary"
  //               fontWeight="bold"
  //               sx={{ textAlign: "center", width: "100%", mb: 2 }}
  //             >
  //               Available Time Slots
  //             </Typography>
  //           </Box>

  //           {appointmentDetails.length > 0 ? (
  //             <Grid container spacing={2}>
  //               {appointmentDetails.map((appointment, index) => {
  //                 const appointmentDate = new Date(appointment.MT_SLOT_DATE);
  //                 const formattedDate = appointmentDate.toLocaleDateString(
  //                   "en-US",
  //                   {
  //                     weekday: "long",
  //                     year: "numeric",
  //                     month: "long",
  //                     day: "numeric",
  //                   }
  //                 );
  //                 const startTime = new Date(
  //                   `1970-01-01T${appointment.MT_START_TIME}`
  //                 ).toLocaleTimeString("en-US", {
  //                   hour: "numeric",
  //                   minute: "numeric",
  //                   hour12: true,
  //                 });
  //                 const endTime = new Date(
  //                   `1970-01-01T${appointment.MT_END_TIME}`
  //                 ).toLocaleTimeString("en-US", {
  //                   hour: "numeric",
  //                   minute: "numeric",
  //                   hour12: true,
  //                 });

  //                 const endDate = new Date(`${formattedDate} ${endTime}`);
  //                 const currentTime = new Date();

  //                 const isPastDate =
  //                   appointmentDate < new Date().setHours(0, 0, 0, 0);
  //                 const isBookingClosed = currentTime > endDate;
  //                 const isFullyBooked =
  //                   appointment.MT_PATIENT_NO >= appointment.MT_MAXIMUM_PATIENTS;

  //                 return (
  //                   <Grid item xs={12} sm={6} key={index}>
  //                     <Card
  //                       variant="outlined"
  //                       sx={{
  //                         height: '100%',
  //                         borderLeft: `4px solid ${isPastDate || isBookingClosed || isFullyBooked
  //                           ? red[500]
  //                           : green[500]
  //                           }`,
  //                       }}
  //                     >
  //                       <CardContent>
  //                         <Box display="flex" flexDirection="column" height="100%">
  //                           <Box mb={1}>
  //                             <Box display="flex" alignItems="center">
  //                               <FontAwesomeIcon
  //                                 icon={faCalendarAlt}
  //                                 style={{
  //                                   color: blue[500],
  //                                   marginRight: 8,
  //                                 }}
  //                               />
  //                               <Typography variant="subtitle1">
  //                                 {formattedDate}
  //                               </Typography>
  //                             </Box>
  //                           </Box>
  //                           <Box mb={2}>
  //                             <Box display="flex" alignItems="center">
  //                               <FontAwesomeIcon
  //                                 icon={faClock}
  //                                 style={{
  //                                   color: orange[500],
  //                                   marginRight: 8,
  //                                 }}
  //                               />
  //                               <Typography variant="body1">
  //                                 {startTime} - {endTime}
  //                               </Typography>
  //                             </Box>
  //                           </Box>
  //                           <Box mt="auto">
  //                             <Box
  //                               display="flex"
  //                               justifyContent="flex-start"
  //                             >
  //                               {isPastDate ? (
  //                                 <Chip
  //                                   label="Expired"
  //                                   color="error"
  //                                   size="small"
  //                                   sx={{ px: 1 }}
  //                                 />
  //                               ) : isBookingClosed ? (
  //                                 <Chip
  //                                   label="Closed"
  //                                   color="error"
  //                                   size="small"
  //                                   sx={{ px: 1 }}
  //                                 />
  //                               ) : isFullyBooked ? (
  //                                 <Chip
  //                                   label="Fully Booked"
  //                                   color="error"
  //                                   size="small"
  //                                   sx={{ px: 1 }}
  //                                 />
  //                               ) : (
  //                                 <BookButton
  //                                   variant="contained"
  //                                   size="small"
  //                                   onClick={() => handleBookNowClick(appointment)}

  //                                 >
  //                                   Book Now
  //                                 </BookButton>
  //                               )}
  //                             </Box>
  //                             {!isPastDate &&
  //                               !isBookingClosed &&
  //                               !isFullyBooked && (
  //                                 <Box mt={1}>
  //                                   <Typography
  //                                     variant="caption"
  //                                     color="text.secondary"
  //                                   >
  //                                     {appointment.MT_MAXIMUM_PATIENTS -
  //                                       appointment.MT_PATIENT_NO}{" "}
  //                                     slots remaining
  //                                   </Typography>
  //                                 </Box>
  //                               )}
  //                           </Box>
  //                         </Box>
  //                       </CardContent>
  //                     </Card>
  //                   </Grid>
  //                 );
  //               })}
  //             </Grid>
  //           ) : (
  //             <Box
  //               display="flex"
  //               flexDirection="column"
  //               alignItems="center"
  //               justifyContent="center"
  //               minHeight="200px"
  //             >
  //               <Typography variant="h6" color="text.secondary" gutterBottom>
  //                 No appointments available
  //               </Typography>
  //               <Typography variant="body2" color="text.secondary">
  //                 Please check back later or try another doctor
  //               </Typography>
  //             </Box>
  //           )}
  //         </CardContent>
  //       </Box>
  //     </Container>
  //   </Slide>
  // );


  //With date filtering process
  const renderScreen3 = () => {
    const groupedAppointments = appointmentDetails
      .reduce((groups, appointment) => {
        const date = appointment.MT_SLOT_DATE;
        if (!groups[date]) groups[date] = [];
        groups[date].push(appointment);
        return groups;
      }, {});

    const sortedDates = Object.keys(groupedAppointments)
      .sort((a, b) => new Date(a) - new Date(b));

    return (
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #3b82f6 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: { xs: 2, md: 4 },
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            pointerEvents: 'none',
          },
        }}
      >
        <Slide direction="up" in={true} mountOnEnter unmountOnExit>
          <Container maxWidth="xl" sx={{ width: '100%' }}>
            <Card
              sx={{
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(20px)',
                borderRadius: '24px',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
                overflow: 'visible',
              }}
            >
              <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
                <Box 
                  display="flex" 
                  alignItems="center" 
                  mb={4}
                  sx={{
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                    onClick={handleBackClick}
                    variant="outlined"
                    sx={{
                      mr: { sm: 2 },
                      color: 'white',
                      borderColor: 'rgba(255, 255, 255, 0.3)',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(10px)',
                      borderRadius: '25px',
                      px: 3,
                      py: 1,
                      fontWeight: 600,
                      '&:hover': {
                        borderColor: 'rgba(255, 255, 255, 0.5)',
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 8px 25px rgba(0, 0, 0, 0.2)',
                      },
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    }}
                  >
                    Back
                  </Button>
                  <Typography
                    variant="h4"
                    component="h1"
                    gutterBottom
                    sx={{
                      textAlign: { xs: 'center', sm: 'center' },
                      width: '100%',
                      mb: 0,
                      fontWeight: 700,
                      background: 'linear-gradient(135deg, #ffffff 0%, #f0f8ff 100%)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      color: 'transparent',
                      textShadow: '0 4px 20px rgba(255, 255, 255, 0.3)',
                      fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' },
                    }}
                  >
                    Available Time Slots
                  </Typography>
                </Box>

              {appointmentDetails.length > 0 ? (
                <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'stretch' }}>
                  {sortedDates.flatMap(date =>
                    groupedAppointments[date].map((appointment, index) => {
                      const appointmentDate = new Date(appointment.MT_SLOT_DATE);
                      const formattedDate = appointmentDate.toLocaleDateString(
                        "en-US",
                        {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        }
                      );
                      const startTime = new Date(
                        `1970-01-01T${appointment.MT_START_TIME}`
                      ).toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                      });
                      const endTime = new Date(
                        `1970-01-01T${appointment.MT_END_TIME}`
                      ).toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                      });

                      const endDate = new Date(`${formattedDate} ${endTime}`);
                      const currentTime = new Date();

                      const isPastDate =
                        appointmentDate < new Date().setHours(0, 0, 0, 0);
                      const isBookingClosed = currentTime > endDate;
                      const isFullyBooked =
                        appointment.MT_PATIENT_NO >= appointment.MT_MAXIMUM_PATIENTS;

                      return (
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} key={`${date}-${index}`} sx={{ display: 'flex', justifyContent: 'center' }}>
                          <Card
                            sx={{
                              height: '320px', // Fixed height for all cards
                              minHeight: '320px',
                              maxHeight: '320px',
                              width: '100%',
                              minWidth: '300px',
                              maxWidth: '350px',
                              flex: '1 1 auto',
                              background: isPastDate || isBookingClosed || isFullyBooked 
                                ? 'rgba(255, 255, 255, 0.08)' 
                                : 'rgba(255, 255, 255, 0.15)',
                              backdropFilter: 'blur(15px)',
                              borderRadius: '20px',
                              border: '1px solid rgba(255, 255, 255, 0.2)',
                              boxShadow: '0 12px 30px rgba(0, 0, 0, 0.1)',
                              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                              position: 'relative',
                              overflow: 'hidden',
                              display: 'flex',
                              flexDirection: 'column',
                              '&:hover': !isPastDate && !isBookingClosed && !isFullyBooked ? {
                                transform: 'translateY(-8px)',
                                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
                                background: 'rgba(255, 255, 255, 0.25)',
                              } : {},
                              '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: '4px',
                                background: isPastDate || isBookingClosed || isFullyBooked
                                  ? 'linear-gradient(90deg, #ff6b6b, #ee5a24)'
                                  : 'linear-gradient(90deg, #3b82f6, #1e40af, #2563eb)',
                              },
                            }}
                          >
                            <CardContent sx={{ 
                              p: 3, 
                              height: '100%', 
                              display: 'flex', 
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              position: 'relative',
                              zIndex: 2,
                              '&:last-child': { pb: 3 }
                            }}>
                              <Box display="flex" flexDirection="column" height="100%">
                                <Box mb={2} sx={{ height: '75px', minHeight: '75px', maxHeight: '75px', display: 'flex', alignItems: 'center' }}>
                                  <Box display="flex" alignItems="center" width="100%" sx={{
                                    background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 197, 253, 0.1) 100%)',
                                    borderRadius: '15px',
                                    p: 2,
                                    border: '1px solid rgba(59, 130, 246, 0.15)'
                                  }}>
                                    <Box
                                      sx={{
                                        background: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)',
                                        borderRadius: '50%',
                                        width: 40,
                                        height: 40,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 2,
                                        boxShadow: '0 6px 15px rgba(59, 130, 246, 0.4)',
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={faCalendarAlt}
                                        style={{
                                          color: 'white',
                                          fontSize: '16px',
                                        }}
                                      />
                                    </Box>
                                    <Typography 
                                      variant="subtitle2" 
                                      fontWeight="700"
                                      sx={{ 
                                        color: '#1E40AF',
                                        fontSize: '0.85rem',
                                        lineHeight: 1.2,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical'
                                      }}
                                    >
                                      {formattedDate}
                                    </Typography>
                                  </Box>
                                </Box>
                                
                                <Box mb={2} sx={{ height: '65px', minHeight: '65px', maxHeight: '65px', display: 'flex', alignItems: 'center' }}>
                                  <Box display="flex" alignItems="center" width="100%" sx={{
                                    background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%)',
                                    borderRadius: '15px',
                                    p: 2,
                                    border: '1px solid rgba(37, 99, 235, 0.15)'
                                  }}>
                                    <Box
                                      sx={{
                                        background: 'linear-gradient(135deg, #2563EB 0%, #1E40AF 100%)',
                                        borderRadius: '50%',
                                        width: 40,
                                        height: 40,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 2,
                                        boxShadow: '0 6px 15px rgba(37, 99, 235, 0.4)',
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={faClock}
                                        style={{
                                          color: 'white',
                                          fontSize: '16px',
                                        }}
                                      />
                                    </Box>
                                    <Box>
                                      <Typography 
                                        variant="body2" 
                                        fontWeight="700"
                                        sx={{ 
                                          color: '#1E40AF',
                                          fontSize: '0.9rem',
                                          lineHeight: 1.2,
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap'
                                        }}
                                      >
                                        {startTime} - {endTime}
                                      </Typography>
                                      {selectedAppointment && selectedAppointment.MT_SLOT_ID === appointment.MT_SLOT_ID && (
                                        <Typography 
                                          variant="caption"
                                          sx={{
                                            color: '#ffd700',
                                            fontWeight: 600,
                                            fontSize: '0.75rem',
                                            textShadow: '0 2px 10px rgba(255, 215, 0, 0.5)',
                                          }}
                                        >
                                          ⭐ Your Time
                                        </Typography>
                                      )}
                                    </Box>
                                  </Box>
                                </Box>
                                
                                <Box mt="auto" sx={{ height: '100px', minHeight: '100px', maxHeight: '100px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                    {isPastDate ? (
                                      <Chip
                                        label="Expired"
                                        size="medium"
                                        sx={{
                                          px: 3,
                                          py: 1,
                                          background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
                                          color: 'white',
                                          fontWeight: 700,
                                          fontSize: '0.8rem',
                                          borderRadius: '25px',
                                          boxShadow: '0 4px 15px rgba(239, 68, 68, 0.3)',
                                          border: 'none',
                                          '& .MuiChip-label': { px: 2 }
                                        }}
                                      />
                                    ) : isBookingClosed ? (
                                      <Chip
                                        label="Closed"
                                        size="medium"
                                        sx={{
                                          px: 3,
                                          py: 1,
                                          background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
                                          color: 'white',
                                          fontWeight: 700,
                                          fontSize: '0.8rem',
                                          borderRadius: '25px',
                                          boxShadow: '0 4px 15px rgba(239, 68, 68, 0.3)',
                                          border: 'none',
                                          '& .MuiChip-label': { px: 2 }
                                        }}
                                      />
                                    ) : isFullyBooked ? (
                                      <Chip
                                        label="Fully Booked"
                                        size="medium"
                                        sx={{
                                          px: 3,
                                          py: 1,
                                          background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
                                          color: 'white',
                                          fontWeight: 700,
                                          fontSize: '0.8rem',
                                          borderRadius: '25px',
                                          boxShadow: '0 4px 15px rgba(239, 68, 68, 0.3)',
                                          border: 'none',
                                          '& .MuiChip-label': { px: 2 }
                                        }}
                                      />
                                    ) : (
                                      <Button
                                        variant="contained"
                                        size="medium"
                                        onClick={() => handleBookNowClick(appointment)}
                                        sx={{
                                          background: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)',
                                          color: 'white',
                                          borderRadius: '20px',
                                          px: 3.5,
                                          py: 1.2,
                                          fontWeight: 700,
                                          fontSize: '0.85rem',
                                          textTransform: 'none',
                                          boxShadow: '0 6px 20px rgba(59, 130, 246, 0.4)',
                                          minWidth: '130px',
                                          maxWidth: '150px',
                                          height: '40px',
                                          '&:hover': {
                                            background: 'linear-gradient(135deg, #2563EB 0%, #1E40AF 100%)',
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 8px 25px rgba(59, 130, 246, 0.5)',
                                          },
                                          transition: 'all 0.3s ease',
                                          fontWeight: 600,
                                          textTransform: 'none',
                                          boxShadow: '0 4px 15px rgba(59, 130, 246, 0.3)',
                                          '&:hover': {
                                            background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 6px 20px rgba(59, 130, 246, 0.4)',
                                          },
                                          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        }}
                                      >
                                        📅 Book Now
                                      </Button>
                                    )}
                                  </Box>
                                  {!isPastDate && !isBookingClosed && !isFullyBooked && (
                                    <Box>
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          color: 'rgba(255, 255, 255, 0.8)',
                                          fontSize: '0.75rem',
                                          fontWeight: 500,
                                        }}
                                      >
                                        {appointment.MT_MAXIMUM_PATIENTS - appointment.MT_PATIENT_NO} slots remaining
                                      </Typography>
                                    </Box>
                                  )}
                                </Box>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })
                  )}
                </Grid>
              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  minHeight="300px"
                  sx={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '20px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(10px)',
                    p: 4,
                  }}
                >
                  <FontAwesomeIcon 
                    icon={faClock} 
                    style={{ 
                      fontSize: '4rem', 
                      color: 'rgba(255, 255, 255, 0.6)', 
                      marginBottom: '16px' 
                    }} 
                  />
                  <Typography 
                    variant="h6" 
                    gutterBottom
                    sx={{
                      color: 'white',
                      textAlign: 'center',
                      fontWeight: 600,
                    }}
                  >
                    No appointments available
                  </Typography>
                  <Typography 
                    variant="body2"
                    sx={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textAlign: 'center',
                    }}
                  >
                    Please check back later or try another doctor
                  </Typography>
                </Box>
              )}
              </CardContent>
            </Card>
          </Container>
        </Slide>
      </Box>
    );
  };

  const renderScreen4 = () => {
    if (!selectedAppointment) return null;

    const startTime = new Date(
      `1970-01-01T${selectedAppointment.MT_START_TIME}`
    ).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    const endTime = new Date(
      `1970-01-01T${selectedAppointment.MT_END_TIME}`
    ).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    const allocatedTime = new Date(
      `1970-01-01T${selectedAppointment.MT_ALLOCATED_TIME}`
    ).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    const appointmentDate = new Date(selectedAppointment.MT_SLOT_DATE);
    const formattedDate = appointmentDate.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    return (
      <Dialog
        open={true}
        TransitionComponent={Transition}
        keepMounted
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: isMobile ? 0 : '24px',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
            overflow: 'hidden',
          },
          "& .MuiBackdrop-root": {
            background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.4) 0%, rgba(63, 79, 225, 0.4) 50%, rgba(50, 21, 193, 0.4) 100%)',
            backdropFilter: 'blur(8px)',
          },
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #3f47dcff 50%, #2c13eaff 100%)',
            color: "white",
            py: 3,
            textAlign: 'center',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '1px',
              background: 'rgba(255, 255, 255, 0.3)',
            },
          }}
        >
          <Typography 
            variant="h5" 
            fontWeight="bold"
            sx={{
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
            }}
          >
            <FontAwesomeIcon icon={faCheckCircle} />
            Confirm Appointment
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ py: 4, px: 4 }}>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                background: 'linear-gradient(135deg, #667eea 0%, #0e107dff 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
                mb: 2,
                textAlign: 'center',
              }}
            >
              Appointment Summary
            </Typography>
            <Divider 
              sx={{ 
                mb: 3,
                background: 'linear-gradient(90deg, transparent, #667eea, transparent)',
                height: '2px',
                border: 'none',
              }} 
            />
            
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                    border: '1px solid rgba(102, 126, 234, 0.2)',
                    borderRadius: '16px',
                    p: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 25px rgba(102, 126, 234, 0.15)',
                    },
                  }}
                >
                  <Box display="flex" alignItems="center" mb={1}>
                    <FontAwesomeIcon 
                      icon={faUser} 
                      style={{ 
                        color: '#667eea', 
                        marginRight: '8px',
                        fontSize: '1.1rem'
                      }} 
                    />
                    <Typography variant="body2" color="text.secondary" fontWeight={600}>
                      Patient Name
                    </Typography>
                  </Box>
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    {name}
                  </Typography>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    background: 'linear-gradient(135deg, rgba(118, 75, 162, 0.1) 0%, rgba(240, 147, 251, 0.1) 100%)',
                    border: '1px solid rgba(118, 75, 162, 0.2)',
                    borderRadius: '16px',
                    p: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 25px rgba(118, 75, 162, 0.15)',
                    },
                  }}
                >
                  <Box display="flex" alignItems="center" mb={1}>
                    <FontAwesomeIcon 
                      icon={faPhone} 
                      style={{ 
                        color: '#764ba2', 
                        marginRight: '8px',
                        fontSize: '1.1rem'
                      }} 
                    />
                    <Typography variant="body2" color="text.secondary" fontWeight={600}>
                      Contact Number
                    </Typography>
                  </Box>
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    {contact}
                  </Typography>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    background: 'linear-gradient(135deg, rgba(240, 147, 251, 0.1) 0%, rgba(102, 126, 234, 0.1) 100%)',
                    border: '1px solid rgba(240, 147, 251, 0.2)',
                    borderRadius: '16px',
                    p: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 25px rgba(240, 147, 251, 0.15)',
                    },
                  }}
                >
                  <Box display="flex" alignItems="center" mb={1}>
                    <FontAwesomeIcon 
                      icon={faUserMd} 
                      style={{ 
                        color: '#f093fb', 
                        marginRight: '8px',
                        fontSize: '1.1rem'
                      }} 
                    />
                    <Typography variant="body2" color="text.secondary" fontWeight={600}>
                      Doctor
                    </Typography>
                  </Box>
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    {selectedAppointment.MT_DOCTOR}
                  </Typography>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    background: 'linear-gradient(135deg, rgba(118, 75, 162, 0.1) 0%, rgba(102, 126, 234, 0.1) 100%)',
                    border: '1px solid rgba(118, 75, 162, 0.2)',
                    borderRadius: '16px',
                    p: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 25px rgba(118, 75, 162, 0.15)',
                    },
                  }}
                >
                  <Box display="flex" alignItems="center" mb={1}>
                    <FontAwesomeIcon 
                      icon={faClock} 
                      style={{ 
                        color: '#764ba2', 
                        marginRight: '8px',
                        fontSize: '1.1rem'
                      }} 
                    />
                    <Typography variant="body2" color="text.secondary" fontWeight={600}>
                      Doctor's Availability
                    </Typography>
                  </Box>
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    {startTime} - {endTime}
                  </Typography>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(240, 147, 251, 0.1) 100%)',
                    border: '1px solid rgba(102, 126, 234, 0.2)',
                    borderRadius: '16px',
                    p: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 25px rgba(102, 126, 234, 0.15)',
                    },
                  }}
                >
                  <Box display="flex" alignItems="center" mb={1}>
                    <FontAwesomeIcon 
                      icon={faCalendarAlt} 
                      style={{ 
                        color: '#667eea', 
                        marginRight: '8px',
                        fontSize: '1.1rem'
                      }} 
                    />
                    <Typography variant="body2" color="text.secondary" fontWeight={600}>
                      Date
                    </Typography>
                  </Box>
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    {formattedDate}
                  </Typography>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    background: 'linear-gradient(135deg, #ffd700 0%, #ffb347 100%)',
                    border: '2px solid #ffd700',
                    borderRadius: '20px',
                    p: 3,
                    textAlign: 'center',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 8px 25px rgba(255, 215, 0, 0.3)',
                    animation: 'pulse 2s infinite',
                    '@keyframes pulse': {
                      '0%': {
                        boxShadow: '0 8px 25px rgba(255, 215, 0, 0.3)',
                      },
                      '50%': {
                        boxShadow: '0 12px 35px rgba(255, 215, 0, 0.5)',
                      },
                      '100%': {
                        boxShadow: '0 8px 25px rgba(255, 215, 0, 0.3)',
                      },
                    },
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: '-100%',
                      width: '100%',
                      height: '100%',
                      background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
                      animation: 'shimmer 3s infinite',
                    },
                    '@keyframes shimmer': {
                      '0%': { left: '-100%' },
                      '100%': { left: '100%' },
                    },
                  }}
                >
                  <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                    <Typography 
                      variant="body1" 
                      fontWeight="bold" 
                      sx={{ 
                        color: '#333',
                        fontSize: '1.1rem',
                      }}
                    >
                      ⭐ Your Time
                    </Typography>
                  </Box>
                  <Typography 
                    variant="h4" 
                    fontWeight="bold" 
                    sx={{ 
                      color: '#333', 
                      textShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                      fontSize: { xs: '1.8rem', sm: '2.2rem' },
                    }}
                  >
                    {allocatedTime}
                  </Typography>
                </Card>
              </Grid>
            </Grid>
          </Box>
          
          <Alert 
            severity="info" 
            sx={{ 
              mb: 2,
              borderRadius: '16px',
              background: 'linear-gradient(135deg, rgba(2, 136, 209, 0.1) 0%, rgba(2, 136, 209, 0.05) 100%)',
              border: '1px solid rgba(2, 136, 209, 0.2)',
              '& .MuiAlert-icon': {
                color: '#0288d1',
              },
            }}
          >
            <Typography variant="body2" fontWeight={600}>
              Please arrive 10 minutes before your scheduled appointment time for a smooth experience.
            </Typography>
          </Alert>
        </DialogContent>
        <DialogActions 
          sx={{ 
            px: 4, 
            py: 3,
            background: 'rgba(102, 126, 234, 0.05)',
            borderTop: '1px solid rgba(102, 126, 234, 0.1)',
            gap: 2,
            justifyContent: 'center',
          }}
        >
          <Button
            onClick={handleBackClick}
            variant="outlined"
            startIcon={<FontAwesomeIcon icon={faTimes} />}
            sx={{
              borderRadius: '12px',
              px: 4,
              py: 1.5,
              color: '#666',
              borderColor: 'rgba(102, 126, 234, 0.3)',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(10px)',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: '140px',
              '&:hover': {
                borderColor: '#667eea',
                backgroundColor: 'rgba(102, 126, 234, 0.1)',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(102, 126, 234, 0.2)',
              },
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            startIcon={<FontAwesomeIcon icon={faCheckCircle} />}
            sx={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '12px',
              px: 4,
              py: 1.5,
              color: 'white',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: '160px',
              boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                transform: 'translateY(-2px)',
                boxShadow: '0 12px 35px rgba(102, 126, 234, 0.4)',
              },
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          >
            Confirm Booking
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderScreen5 = () => (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #748cf5ff 0%, #3e62bcff 50%, #2139bfff 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: { xs: 2, md: 4 },
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 50%)',
          pointerEvents: 'none',
        },
      }}>
        <Container maxWidth="sm">
          <Card sx={{
            background: 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(20px)',
            borderRadius: '24px',
            border: '1px solid rgba(255,255,255,0.2)',
            boxShadow: '0 25px 50px rgba(0,0,0,0.15)',
            overflow: 'hidden',
            position: 'relative',
          }}>
            <CardContent
              sx={{
                p: { xs: 3, md: 6 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  width: { xs: 100, md: 120 },
                  height: { xs: 100, md: 120 },
                  borderRadius: "50%",
                  background: 'linear-gradient(135deg, #667eea 0%, #1a17c1ff 100%)',
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 4,
                  position: 'relative',
                  boxShadow: '0 15px 35px rgba(102, 126, 234, 0.3)',
                  animation: 'pulse 2s infinite',
                  '@keyframes pulse': {
                    '0%': {
                      boxShadow: '0 15px 35px rgba(102, 126, 234, 0.3)',
                    },
                    '50%': {
                      boxShadow: '0 20px 45px rgba(102, 126, 234, 0.5)',
                      transform: 'scale(1.05)',
                    },
                    '100%': {
                      boxShadow: '0 15px 35px rgba(102, 126, 234, 0.3)',
                    },
                  },
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: '-10px',
                    left: '-10px',
                    right: '-10px',
                    bottom: '-10px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%)',
                    animation: 'rotate 3s linear infinite',
                    zIndex: -1,
                  },
                  '@keyframes rotate': {
                    '0%': { transform: 'rotate(0deg)' },
                    '100%': { transform: 'rotate(360deg)' },
                  },
                }}
              >
                <FontAwesomeIcon 
                  icon={faCheckCircle} 
                  style={{ 
                    color: 'white', 
                    fontSize: '3rem',
                    filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))'
                  }} 
                />
              </Box>
              
              <Typography
                variant="h3"
                component="h1"
                gutterBottom
                sx={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  color: 'transparent',
                  fontWeight: 'bold',
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  textShadow: '0 4px 20px rgba(102, 126, 234, 0.3)',
                  mb: 3,
                }}
              >
                🎉 Appointment Confirmed!
              </Typography>
              
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#2c3e50', 
                  fontWeight: 600, 
                  mb: 2,
                  fontSize: { xs: '1.1rem', md: '1.25rem' }
                }}
              >
                Your appointment with <span style={{ 
                  background: 'linear-gradient(135deg, #667eea 0%, #2f2bb7ff 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  color: 'transparent',
                  fontWeight: 'bold'
                }}>{selectedDoctor}</span> has been successfully booked!
              </Typography>
              
              <Box sx={{
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                borderRadius: '16px',
                p: 3,
                mb: 3,
                border: '1px solid rgba(102, 126, 234, 0.2)',
                width: '100%',
                maxWidth: 400,
              }}>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: '#34495e', 
                    lineHeight: 1.8,
                    fontSize: '1rem',
                    fontWeight: 500,
                  }}
                >
                  📧 We've sent the appointment details to your registered contact information.
                </Typography>
              </Box>
              
              <Box sx={{
                background: 'linear-gradient(135deg, #ffd700 0%, #ffb347 100%)',
                borderRadius: '16px',
                p: 2,
                mb: 2,
                border: '2px solid #ffd700',
                width: '100%',
                maxWidth: 400,
                boxShadow: '0 8px 25px rgba(255, 215, 0, 0.2)',
              }}>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#333', 
                    fontWeight: 600,
                    fontSize: '0.9rem',
                  }}
                >
                  ⚡ Please arrive 10 minutes early for check-in
                </Typography>
              </Box>
              
              <Box
                sx={{
                  mt: 4,
                  p: 3,
                  background: 'linear-gradient(135deg, rgba(240, 147, 251, 0.1) 0%, rgba(102, 126, 234, 0.1) 100%)',
                  borderRadius: '20px',
                  border: '1px solid rgba(240, 147, 251, 0.2)',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: '#667eea', 
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                  }}
                >
                  Thank you for choosing our services! 🙏
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#7f8c8d', 
                    textAlign: 'center',
                    fontSize: '0.95rem',
                    lineHeight: 1.6,
                  }}
                >
                  If you need to reschedule or have any questions, please contact our support team.
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </motion.div>
  );

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "60vh",
        backgroundColor: theme.palette.background.default,
      }}
    >
      {currentScreen > 1 && currentScreen < 4 && (
        <Container maxWidth="lg" sx={{ py: 2 }}>
          <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Container>
      )}

      {/* {currentScreen === 1 && renderScreen1()} */}
      {currentScreen === 2 && renderScreen2()}
      {currentScreen === 3 && renderScreen3()}
      {currentScreen === 4 && renderScreen4()}
      {currentScreen === 5 && renderScreen5()}

      <Snackbar
        open={openSuccess}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        TransitionComponent={Fade}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Login successful! You can now book appointments.
        </Alert>
      </Snackbar>

      <Snackbar
        open={!!errormeassage}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        TransitionComponent={Fade}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {errormeassage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
